module.exports = __webpack_public_path__ + "img/shirt.1c577f84.svg";